// System, Light or Dark (docs/DESIGN.md, Foundations). Stored in this browser only — it's a
// preference about a screen, not about a person, and this app stores nothing about who you are.
//
// tokens.css follows the operating system unless <html data-theme> says otherwise, so "system"
// is the ABSENCE of the attribute rather than a third value.

export type Appearance = "system" | "light" | "dark";
const KEY = "preva.appearance";

export function savedAppearance(): Appearance {
  try {
    const v = localStorage.getItem(KEY);
    return v === "light" || v === "dark" ? v : "system";
  } catch {
    return "system";
  }
}

export function applyAppearance(a: Appearance): void {
  const root = document.documentElement;
  if (a === "system") delete root.dataset.theme;
  else root.dataset.theme = a;
  try {
    if (a === "system") localStorage.removeItem(KEY);
    else localStorage.setItem(KEY, a);
  } catch { /* storage blocked: the choice lasts this page, which is still right */ }
}
